/**
 * CargaOpenlogCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'

/* TODO: review generated class */
@HttpExclude()
export class CargaOpenlogCollection extends PageCollection<CargaOpenlog> {
  constructor() {
    super(CargaOpenlog)
  }

  queryAsPage() {
    return this.listCargaOpenlog()
  }

  async listCargaOpenlog() {
    return await Request.get(`/admin/carga-openlog`, {params: this.params})
      .name('listCargaOpenlog')
      .as(this)
      .getResponse()
  }

  async listCsvCargaOpenlog() {
    return await Request.get(`/admin/carga-openlog/csv`, {params: this.params})
      .name('listCsvCargaOpenlog')
      .as(this)
      .getResponse()
  }
}
